export const ru = {
    common: {
        yes: 'Yes',
        no: 'No',
        at: 'at',
        do: 'do',
        all: 'Все',
        loading: 'Загрузка',
        simple: 'Простая',
        notSelected: 'Не выбрано',
        noProbes: 'Нет проб',
        noBlends: 'Нет смесей',
        noColumns: 'Нет колонок',
        samples: 'Пробы',
        blends: 'Смеси',
        component: 'Компонент',
        components: 'Компоненты',
        componentsAndSettings: 'Компоненты и свойства',
        projectSettings: 'Свойства проекта',
        quantity: 'Количество',
        settings: 'Настройки',
        versions: 'Версии',
        project: 'Проект',
        hm: 'Хм...',
        name: 'Имя',
        addComponent: 'Добавить компонент',
        noComponents: 'Нет компонентов',
        boilingPoint: 'Температура кипения',
        total: 'Итого',
        select: 'Выберите',
        element: 'Элемент',
        parameter: 'Параметр',
        value: 'Значение',
        share: 'Общие',
        favorites: 'Избранные',
        composition: 'Состав',
        mocked: 'Моковые',
        bin: 'Корзина',
        task: 'Задача',
        journalEmpty: 'Журнал пуст',
        noData: 'Нет данных',
        optionNotSelected: 'Опция не выбрана',
        noResults: 'Нет результатов',
        jsFormError: 'Ошибка в поле JsonForm',
        appError: 'Хм... Произошла ошибка',
        acceptableError: 'Допустимая ошибка',
        datasetError: 'Ошибка в данных',
        prefix: 'Префикс',
        sum: 'Cумма',
        results: 'Результаты',
        empty: 'Пусто',
        dataset: 'Данные',
        noParams: 'Нет параметров',
        chooseProp: 'Выбор характеристики',
        min: 'Минимум',
        max: 'Максимум',
        recentData: 'Недавние данные',
        selectRow: 'Выберите строку',
        expandAll: 'Всё развёрнуто',
        calculation: 'Расчёт',
        sort: 'Сортировка',
        delete: 'Удаление'
    },
    actions: {
        create: 'Создать',
        upload: 'Загрузить',
        download: 'Скачать',
        duplicate: 'Дублировать',
        rename: 'Переименовать',
        delete: 'Удалить',
        select: 'Выбрать',
        deleteComplexUse: 'Удалить (Компонент составного элемента)',
        toBin: 'В корзину',
        restore: 'Восстановить',
        cancel: 'Отмена',
        close: 'Закрыть',
        tryAgain: 'Попробовать ещё раз',
        add: 'Добавить',
        addFrom: 'Добавить из...',
        search: 'Поиск',
        import: 'Импорт',
        export: 'Экспорт',
        normalize: 'Нормализовать',
        showMore: 'Раскрыть',
        showLess: 'Свернуть',
        addFlow: 'Добавить поток',
        calcCoefficients: 'Рассчитать коэффициенты',
        calculate: 'Рассчитать',
        connectProperties: 'Связывание характеристик',
        clearDataset: 'Очистить набор данных',
        clearDatasetShort: 'Очистить данные',
        deleteDataset: 'Удалить все колонки и данные',
        deleteDatasetShort: 'Удалить данные',
        developerMode: 'Режим разработчика',
        copyToClipboard: 'Скопировать в буфер',
        logout: 'Выйти'
    },
    labels: {
        exampleOf: 'Пример «{{name}}»',
        clipboard: 'Буфер обмена',
        copyError: 'Ошибка копирования',
        objectCopied: 'Объект «{{name}}» скопирован в буфер',
        turnOnInspector: 'Включить инспектор',
        turnOffInspector: 'Выключить инспектор'
    },
    auth: {
        error: 'Ошибка авторизации'
    },
    error: {
        fieldValue: 'Неверное значение поля',
        server: 'Ошибка сервера',
        serverCode: 'Сервер вернул ошибку {{code}}.'
    },
    enum: {
        uom: {
            molar_flow_rate: 'Мольный расход',
            mass_flow_rate: 'Массовый расход',
            volumetric_flow_rate: 'Объемный расход'
        },
        projectType: {
            SAMPLES_AND_OIL_BLEND: 'Пробы и смеси',
            TECH_PROCESS: 'Техпроцесс'
        },
        dumpReasonType: {
            before_run: 'До запуска',
            after_run: 'После запуска'
        },
        logicalElement: {
            recycle: 'Рецикл',
            function: 'Функция',
            optimization: 'Оптимизатор',
            set: 'Уставка',
            cutter: 'Cutter'
        },
        element: {
            TwoPhaseSeparatorElement: 'Сеп. 2-фазный',
            ThreePhaseSeparatorElement: 'Сеп. 3-фазный',
            CatCrackingElement: 'Уст. кат. крекинга',
            CatCrackingReactorRegeneratorBlockElement: 'Реакт.-реген. блок кат. крекинга',
            CatReformingElement: 'Уст. кат. риформинга',
            CatReformingReactorBlockElement: 'Реакт. блок кат. риформинга',
            DistillationColumnWithReboilerAndCapacitorElement: 'Рект. кол. с реб. и конд.',
            CompressorElement: 'Компрессор',
            CokerElement: 'УЗК',
            CokerReactorBlockElement: 'Реакт. блок УЗК',
            CoolerElement: 'Охладитель',
            DieselFuelHydrotreatingElement: 'Гидроочистка ДТ',
            DieselFuelHydrotreatingReactorBlockElement: 'Реакт. блок гидроочистки ДТ',
            ValveElement: 'Клапан',
            EnergyFlowElement: 'Энерг. поток',
            MaterialFlowElement: 'Матер. поток',
            HeaterElement: 'Нагреватель',
            HeatExchangerElement: 'Теплообменник',
            PumpElement: 'Насос',
            DetanderElement: 'Детандер',
            SplitterElement: 'Делитель',
            ComponentSplitterElement: 'Делитель компонентов',
            AbsorberElement: 'Абсорбер',
            WaterJetPumpElement: 'Эжектор',
            MixerElement: 'Смеситель',
            TeeElement: 'Делитель',
            PipelineElement: 'Трубопровод',
            FractionatorElement: 'Фракционатор',
            ConversionReactorElement: 'Конверс. реактор',
            EquilibriumReactorElement: 'Равнов. реактор',
            HeatExchangerSynthetic: 'Теплообменник (с)',
            MultiStepCoherent: 'Многошаг. без вн. моделей (с)',
            MultiStepExternal: 'Многошаг. с вн. моделями (с)',
            Balancer: 'Балансировщик (с)',
            EngineTestSynthetic: 'Синт. модуль тест. выч. движка',
            long: {
                TwoPhaseSeparatorElement: 'Сепаратор 2-фазный',
                ThreePhaseSeparatorElement: 'Сепаратор 3-фазный',
                CatCrackingElement: 'Установка каталитического крекинга',
                CatCrackingReactorRegeneratorBlockElement: 'Реакторно-регенераторный блок кат. крекинга',
                CatReformingElement: 'Установка каталитического риформинга',
                CatReformingReactorBlockElement: 'Реакторный блок кат. риформинга',
                DieselFuelHydrotreatingElement: 'Гидроочистка дизельного топлива',
                DieselFuelHydrotreatingReactorBlockElement: 'Реакторный блок гидроочистки ДТ',
                DistillationColumnWithReboilerAndCapacitorElement: 'Ректификационная колонна с ребойлером и конденсатором',
                CompressorElement: 'Компрессор',
                CokerElement: 'УЗК',
                CokerReactorBlockElement: 'Реакторный блок УЗК',
                CoolerElement: 'Охладитель',
                ValveElement: 'Клапан',
                EnergyFlowElement: 'Энергетический поток',
                MaterialFlowElement: 'Материальный поток',
                HeaterElement: 'Нагреватель',
                HeatExchangerElement: 'Теплообменник',
                PumpElement: 'Насос',
                DetanderElement: 'Детандер',
                SplitterElement: 'Делитель',
                ComponentSplitterElement: 'Делитель компонентов',
                AbsorberElement: 'Абсорбер',
                WaterJetPumpElement: 'Эжектор',
                MixerElement: 'Смеситель',
                TeeElement: 'Делитель',
                PipelineElement: 'Трубопровод',
                FractionatorElement: 'Фракционатор',
                ConversionReactorElement: 'Конверсионный реактор',
                EquilibriumReactorElement: 'Равновесный реактор',
                HeatExchangerSynthetic: 'Теплообменник (с)',
                MultiStepCoherent: 'Многошаг. без вн. моделей (с)',
                MultiStepExternal: 'Многошаг. с вн. моделями (с)',
                Balancer: 'Балансировщик (с)',
                EngineTestSynthetic: 'Синт. модуль тест. выч. движка'
            }
        },
        pipelineGroupSegment: {
            pipe: 'Повороты и отводы',
            bend: 'Соединительные элементы',
            valve: 'Запорная и регулирующая арматура',
            waterMeter: 'Приборы учёта и контроля'
        },
        pipelineSegment: {
            pipe: 'Труба',
            couplingUnion: 'Муфта/соединение',
            teeElbow: 'Тройник угловой',
            teeBranchBlanked: 'Тройник заглушенный',
            swage45Degree: 'Калиброванный переход 45°',
            swageAbrupt: 'Резкий переход',
            bend90_RD1: 'Отвод 90°, радиус 1×D',
            bend90_RD1_5: 'Отвод 90°, радиус 1.5×D',
            bend90_RD2: 'Отвод 90°, радиус 2×D',
            bend90_RD3: 'Отвод 90°, радиус 3×D',
            bend90_RD4: 'Отвод 90°, радиус 4×D',
            bend90_RD6: 'Отвод 90°, радиус 6×D',
            bend90_RD8: 'Отвод 90°, радиус 8×D',
            bend90_RD10: 'Отвод 90°, радиус 10×D',
            bend90_RD12: 'Отвод 90°, радиус 12×D',
            bend90_RD14: 'Отвод 90°, радиус 14×D',
            bend90_RD16: 'Отвод 90°, радиус 16×D',
            bend90_RD20: 'Отвод 90°, радиус 20×D',
            elbow45Long: 'Отвод 45°, удлинённый',
            elbow45Mitre: 'Отвод 45°, из прямых звеньев',
            elbow45Std: 'Отвод 45°, стандартный',
            elbow90Long: 'Отвод 90°, удлинённый',
            elbow90Mitre: 'Отвод 90°, из прямых звеньев',
            elbow90Std: 'Отвод 90°, стандартный',
            degree180CloseReturn: 'Отвод 180°, возвратный закрытый',
            angleValve45Open: 'Клапан угловой 45°, открытый',
            angleValve90Open: 'Клапан угловой 90°, открытый',
            angleValveOpen: 'Клапан угловой, открытый',
            ballValveOpen: 'Кран шаровой, открытый',
            butterflyValve2_8InOpen: 'Затвор дисковый поворотный (бабочка) 50-200, открытый',
            butterflyValve10_14InOpen: 'Затвор дисковый поворотный (бабочка) 250-350, открытый',
            butterflyValve16_24InOpen: 'Затвор дисковый поворотный (бабочка) 400-600, открытый',
            butterflyValveAngle5: 'Затвор дисковый поворотный (бабочка): угол 5°',
            butterflyValveAngle10: 'Затвор дисковый поворотный (бабочка): угол 10°',
            butterflyValveAngle20: 'Затвор дисковый поворотный (бабочка): угол 20°',
            butterflyValveAngle40: 'Затвор дисковый поворотный (бабочка): угол 40°',
            butterflyValveAngle60: 'Затвор дисковый поворотный (бабочка): угол 60°',
            checkValveBall: 'Клапан обратный шаровой',
            checkValveDisk: 'Клапан обратный дисковый',
            checkValveLift: 'Клапан обратный подъёмный',
            checkValve45Lift: 'Клапан обратный подъёмный угловой 45°',
            checkValveSwing: 'Клапан обратный поворотный (захлопка)',
            gateValveCraneOpen: 'Задвижка кранового типа, открытая',
            gateValveOneQuarter: 'Задвижка, 25% открытия',
            gateValveHalf: 'Задвижка, 50% открытия',
            gateValveThreeQuarter: 'Задвижка, 75% открытия',
            gateValveOpen: 'Задвижка, открытая',
            globeValveCraneOpen: 'Клапан запорный, открытый',
            globeValveHalf: 'Клапан запорный, полуоткрытый',
            globeValveOpen: 'Клапан запорный, открыт',
            plugCockAngle5: 'Кран пробковый, угол 5°',
            plugCockAngle10: 'Кран пробковый, угол 10°',
            plugCockAngle20: 'Кран пробковый, угол 20°',
            plugCockAngle40: 'Кран пробковый, угол 40°',
            plugCockAngle60: 'Кран пробковый, угол 60°',
            plugCockOpen: 'Кран пробковый, открытый',
            blowoffValveOpen: 'Клапан продувочный / дренажный / выпускной, открытый',
            diaphragmValveOneQuarter: 'Клапан мембранный, 25% открытия',
            diaphragmValveHalf: 'Клапан мембранный, 50% открытия',
            diaphragmValveThreeQuarter: 'Клапан мембранный, 75% открытия',
            diaphragmValveOpen: 'Клапан мембранный, открытый',
            footValve: 'Заборный клапан',
            footValveHingedDisk: 'Заборный клапан с поворотным диском',
            footValvePoppetDisk: 'Заборный клапан с клапанным затвором',
            waterMeterDisk: 'Водосчётчик дисковый',
            waterMeterPiston: 'Водосчётчик поршневой',
            waterMeterRotary: 'Водосчётчик ротационный',
            waterMeterTurbine: 'Водосчётчик турбинный'
        },
        modelType: {
            Robinson: 'Пенг-Робинсон',
            Separator_2ph: 'Сеп. 2-фазный',
            Separator_3ph: 'Сеп. 3-фазный',
            Coker: 'Реакт. блок УЗК',
            Compressor: 'Компрессор',
            Cooler: 'Охладитель',
            Valve: 'Клапан',
            CPA: 'CPA',
            NRTL: 'NRTL',
            Glycols: 'Гликоли',
            Amines: 'Амины (Кислые газы)',
            SRK: 'SRK',
            long: {
                Robinson: 'Пенг-Робинсон',
                Separator_2ph: 'Сепаратор 2-фазный',
                Separator_3ph: 'Сепаратор 3-фазный',
                Coker: 'Реакторный блок УЗК',
                Compressor: 'Компрессор',
                Cooler: 'Охладитель',
                Valve: 'Клапан',
                CPA: 'CPA',
                NRTL: 'NRTL',
                Glycols: 'Гликоли',
                Amines: 'Амины (Кислые газы)',
                SRK: 'SRK'
            }
        },
        componentBaseType: {
            PURE: 'Чистые',
            LUMP: 'Lump',
            HYPOTHETICAL: 'Гипотетич.',
            PSEUDO: 'Псевдокомп.'
        },
        componentFamilyClass: {
            hydrocarbons: 'Углеводороды',
            halogens: 'Галогены',
            alcohols: 'Спирты',
            aldehydes: 'Альдегиды',
            hydrocarbon_acids: 'Углеводородные кислоты',
            ketones: 'Кетоны',
            non_organic: 'Неорганические',
            sulphurous: 'Серосодержащие',
            phenols: 'Фенолы',
            amines: 'Амины',
            compound_ether: 'Cложные эфиры',
            simple_ether: 'Простые эфиры',
            nitriles: 'Нитрилы',
            others: 'Прочие'
        },
        journalItemType: {
            warning: 'Предупр.',
            error: 'Ошибки'
        },
        operator: {
            LessThan: '<',
            LessThanOrEqual: '<=',
            GreaterThan: '>',
            GreaterThanOrEqual: '>='
        }
    },
    projectList: {
        All: 'Все проекты',
        TechProcess: 'Техпроцессы',
        SamplesBlends: 'Пробы и смеси',
        Shared: 'Общие проекты',
        Favorites: 'Избранные проекты',
        Mocked: 'Моковые проекты',
        Bin: 'Корзина'
    },
    projects: {
        my: 'Мои проекты',
        create: 'Создать проект',
        creation: 'Создание проекта',
        notFound: 'Проекты не найдены',
        techProcesses: 'Техпроцессы',
        samplesAndBlends: 'Пробы и смеси',
        selectType: 'Выберите категорию проекта',
        techProcessesDesc: 'Моделирование химико-технологического процесса',
        samplesAndBlendDesc: 'Расчёт псевдокомпонентного состава пакета нефтей',
        rename: 'Переименовать проект',
        delete: 'Удалить проект',
        deleteQuestion: 'Вы точно хотите удалить проект?',
        deleteSureMsg: 'Восстановить удалённый проект «{{name}}» будет невозможно. Пожалуйста подтвердите удаление.'
    },
    checkpoints: {
        create: 'Создать чекпоинт',
        usePoint: 'Использовать данные расчёта №{{name}}'
    },
    elements: {
        elements: 'Элементы',
        noElements: 'Нет элементов',
        delete: 'Удаление элемента',
        deleteSureMsg: 'Вы уверены, что хотите удалить элементы: «{{name}}»?'
    },
    logicalElements: {
        elements: 'Логические элементы',
        noElements: 'Нет логических элементов',
        delete: 'Удаление логического элемента',
        deleteSureMsg: 'Вы уверены, что хотите удалить логический элемент «{{name}}»?'
    },
    connections: {
        connections: 'Связи',
        noConnections: 'Нет связей',
        delete: 'Удаление связи',
        deleteSureMsg: 'Вы уверены, что хотите удалить связь?',
        createBetween: 'Создание связи между «{{nodeA}}» и «{{nodeB}}»',
        portName: 'Название порта «{{name}}»'
    },
    models: {
        models: 'Модели',
        noModels: 'Нет моделей',
        delete: 'Удаление модели',
        deleteSureMsg: 'Вы уверены, что хотите удалить модель «{{name}}»?',
        deleteSureMsgError: 'Удаление модели «{{name}}» невозможно, т.к. она используется следующими элементами: {{list}}.'
    },
    samples: {
        samples: 'Пробы',
        noSamples: 'Нет проб',
        delete: 'Удаление пробы',
        results: 'Результаты проб',
        deleteSureMsg: 'Вы уверены, что хотите удалить пробу «{{name}}»?'
    },
    blends: {
        blend: 'Смесь',
        blends: 'Смеси',
        noBlends: 'Нет смесей',
        delete: 'Удаление смеси',
        results: 'Результаты смесей',
        deleteSureMsg: 'Вы уверены, что хотите удалить смесь «{{name}}»?',
        export: 'Скачать смесь',
        import: 'Импорт смеси',
        noSelected: 'Смесь не выбрана',
        prefixMsg: 'Укажите префикс для наименования псевдокомпонентов в составе смеси.'
    },
    fields: {
        name: 'Название',
        category: 'Категория',
        updatedAt: 'Изменён',
        createdAt: 'Создан',
        activity: 'Активность',
        taskType: 'Тип задачи',
        description: 'Описание',
        component: 'Компонент',
        amount: 'Количество',
        tolerance: 'Допуст. отклон.',
        prefix: 'Префикс',
        reaction: 'Реакция',
        rank: 'Ранг',
        lumpComponent: 'Lump-компонент',
        pseudoComponent: 'Псевдокомпонент',
        content: 'Содержание',
        uom: 'Единицы измерения',
        quantity: 'Количество',
        molarMass: 'Молярная масса',
        density: 'Плотность',
        boilingPoint: 'Темпер. кипения',
        connections: 'Связи',
        formula: 'Формула',
        structure: 'Структура',
        type: 'Тип',
        class: 'Класс',
        model: 'Модель',
        keyColumn: 'Ключевая колонка',
        values: 'Значения',
        value: 'Значение',
        currentValue: 'Текущее значение',
        targetValue: 'Целевое значение',
        startValue: 'Начальное значение',
        func: 'Функция',
        inputParams: 'Входные параметры',
        optimizationParams: 'Оптимизированные параметры',
        variableParams: 'Варьируемые параметры',
        optimizationGoal: 'Цель оптимизации',
        param: 'Параметр',
        condition: 'Условие'
    },
    fieldGroups: {
        properties: 'Свойства',
        columns: 'Колонки',
        deleteReset: 'Удаление и сброс'
    },
    rfFields: {
        common: {
            unknownTemplateOf: 'Неизвестный шаблон {{type}}'
        }
    },
    rfZones: {
        tabs: {
            structure: 'Структура',
            calculation: 'Расчёт',
            results: 'Результаты',
            dataset: 'Данные'
        },
        common: {
            noSpace: 'Недостаточно места',
            changeWidth: 'Попробуйте растянуть область'
        }
    },
    jsfields: {
        BinaryCoeffs: {
            name: 'Бинарные коэффициенты',
            calc: 'Рассчитать бинарные коэффициенты'
        },
        CutterDirectComponentMap: {
            name: 'Прямая карта компонентов'
        },
        LogicalElements: {
            empty: 'Нет логических элементов',
            add: 'Добавить логический элемент'
        },
        FlowComposition: {
            phase: 'Фаза',
            uom: 'Единицы измерения'
        },
        VisibleProps: {
            name: 'Название',
            addProps: 'Добавить свойства',
            selectProps: 'Выбрать свойства',
            noProps: 'Нет свойств',
            allGroups: 'Все группы'
        },
        OilSampleModelTable: {
            deleteRange: 'Удалить диапазон',
            addRange: 'Добавить точку разбиения',
            dialogTitle: 'Формулы расчёта',
            formulesPlaceholder: 'Формула'
        },
        OilBlendModel: {
            deleteRange: 'Удалить диапазон',
            addRange: 'Добавить точку разбиения',
            dialogTitle: 'Фракций'
        },
        CompressorCurve: {
            name: 'Имя',
            rotationSpeed: 'Частота вращения',
            flowType: 'Тип расхода',
            pressureType: 'Тип напора',
            efficiency: 'КПД',
            addCurve: 'Добавить кривую',
            copyCurve: 'Скопировать кривую',
            addPoint: 'Добавить точку',
            noCurves: 'Нет кривых'
        },
        ReactionParametersTable: {
            type: 'Тип',
            subType: 'Подтип',
            reaction: 'Реакция',
            energy: 'Энергия активации',
            factor: 'Предэкспонециальный множитель',
            speedConstant: 'Константа скорости',
            temperature: 'Температура'
        },
        ColumnSpecsJsField: {
            order: 'Очередность применения',
            addSpec: 'Добавить набор спецификаций',
            noItems: 'Нет спецификаций'
        },
        ReactionComposition: {
            noItems: 'Нет компонентов',
            addComponent: 'Добавить компонент',
            balance: 'Баланс',
            balanceError: 'Ошибка баланса',
            heatEffect: 'Тепловой эффект',
            table: {
                component: 'Компонент',
                weight: 'Молярная масса',
                coefficient: 'Стеохометр. коэфф.',
                forwardReaction: 'Частный порядок прямой реакции',
                reverseReaction: 'Частный порядок обрятной реакции'
            }
        },
        CatalystsList: {
            noItems: 'Нет катализаторов',
            catalystDetails: 'Детали катализатора',
            basicProperties: 'Базовые свойства',
            calibrationFactors: 'Калибровочные коефициенты',
            kineticParameters: 'Кинетические параметры'
        },
        CatalystsListReforming: {
            noItems: 'Нет катализаторов',
            catalystDetails: 'Детали катализатора',
            basicProperties: 'Базовые свойства'
        },
        HydrotreatingDieselReactorsTable: {
            name: 'Реaктор',
            shelvesNum: 'Кол-во полок катализатора',
            noItems: 'Нет реaкторов',
            add: 'Добавить реактор'
        },
        HydrotreatingDieselCatalystsMappingTable: {
            name: 'Реaктор',
            shelf: 'Полка',
            catalyst: 'Катализатор',
            noItems: 'Нет реaкторов',
            notSelected: 'Не выбран'
        },
        PipelineConfig: {
            noSegments: 'Нет сегментов',
            segmentConfig: 'Конфигурация сегментов',
            addSegment: 'Добавить сегмент',
            deleteSegment: 'Удалить сегмент',
            deletingSegment: 'Удаление сегмента',
            deleteSureMsg: 'Вы действительно хотите удалить сегмент «{{name}}»?'
        }
    },
    components: {
        all: 'Все компоненты',
        no: 'Нет компонентов',
        add: 'Добавить компонент',
        noFavorite: 'Нет избранных компонентов'
    },
    reactions: {
        no: 'Нет реакций',
        add: 'Добавить реaкции',
        emptySearch: 'Реакции не найдены'
    },
    widgets: {
        tableDataInvalid: 'Данные для таблицы невалидны',
        chartDataInvalid: 'Данные для графика невалидны'
    },
    dataset: {
        import: 'Импорт данных',
        selectMsg: 'Выберите .csv файл с набором данных.',
        clearData: 'Очистить только данные',
        clearDataStructure: 'Очистить данные и структуру',
        relateColumn: 'Связать колонку «{{name}}»',
        clearing: 'Очистка данных',
        deleting: 'Удаление данных',
        clearingQuestion: 'Вы действительно хотите очистить набор данных?',
        deletingQuestion: 'Вы действительно хотите удалить все колонки и данные?'
    },
    DialogableContainer: {
        placementTitle: 'Плавающая таблица',
        clickToCollapse: 'Нажмите, чтобы свернуть'
    }
};
//# sourceMappingURL=ru.js.map